import { type RequireAtLeastOne } from '@common/types/utilityTypes';
import classnames from '@common/utils/ui/classnames';
import '@common/styles/components/divider.pcss';

interface ContentDividerProps {
  mt?: number;
  mb?: number;
  my?: number;
  deleting?: boolean;
}

function ContentDivider({
  mt,
  mb,
  my,
  deleting,
}: RequireAtLeastOne<ContentDividerProps>) {
  const dividerStyles = {
    marginTop: (mt ?? my) !== undefined ? (mt ?? my)! * 4 : undefined,
    marginBottom: (mb ?? my) !== undefined ? (mb ?? my)! * 4 : undefined,
  };

  return (
    <hr
      className={classnames({
        'content-divider': true,
        'content-divider--deleting': deleting,
      })}
      style={dividerStyles}
    />
  );
}

export default ContentDivider;
